import React from "react"
import PropTypes from "prop-types"

import { GatsbyImage } from "gatsby-plugin-image"

import ImageTransformer from "../parsers/ImageTransformer"
import WPImageGetter from "../parsers/WPImageGetter"

function WPImage(props) {
  let imageContent

  const otherProps = Object.keys(props)
    .filter(k => {
      return !Object.keys(PROPTYPES_PROXY).includes(k) && k !== `className`
    })
    .reduce((acc, cur) => ({ ...acc, [cur]: props[cur] }), {})

  if (props.mode === DISPLAY_MODE.lazy) {
    const imageNode = props.holder.childNodes.filter(node =>
      node.classNames.trim().split(/\s+/).includes(props.selector),
    )[0]
    imageContent = ImageTransformer(imageNode)

    return (
      <>
        {imageContent && (
          <GatsbyImage
            image={imageContent.image}
            alt={imageContent.alt || props.alt}
          />
        )}
      </>
    )
  }

  imageContent = WPImageGetter(props.holder, props.selector)

  if (props.mode === DISPLAY_MODE.inline) {
    return (
      <div
        className={props.className}
        dangerouslySetInnerHTML={{ __html: imageContent }}
        {...otherProps}
      />
    )
  }

  if (props.children) {
    const children = props.children

    const otherOtherProps = Object.keys(otherProps)
      .filter(k => {
        return !Object.keys(PROPTYPES_PROXY).includes(k) && k !== `children`
      })
      .reduce((acc, cur) => ({ ...acc, [cur]: props[cur] }), {})

    return (
      <>
        <span
          className={props.className}
          {...otherOtherProps}
          dangerouslySetInnerHTML={{ __html: imageContent }}
        />
        {children}
      </>
    )
  }

  return (
    <>
      <span
        className={props.className}
        dangerouslySetInnerHTML={{ __html: imageContent }}
        {...otherProps}
      />
    </>
  )
}

export const DISPLAY_MODE = {
  normal: `normal`,
  inline: `inline`,
  lazy: `lazy`,
}

WPImage.defaultProps = {
  mode: DISPLAY_MODE.normal,
}

const PROPTYPES_PROXY = {
  holder: PropTypes.object.isRequired,
  selector: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(Object.keys(DISPLAY_MODE)).isRequired,
  alt: PropTypes.string,
}
WPImage.propTypes = PROPTYPES_PROXY

export default WPImage
